module.exports = __webpack_public_path__ + "img/plane-up-slash.e713f6a8.svg";